export default __webpack_public_path__ + "static/B0182-149ae33da1908e64014c248427344bd4.png";